import { createContext, useContext, createElement, forwardRef, ComponentType } from 'react'

export const LockableContext = createContext(false)

export function useLockable() {
  return useContext(LockableContext)
}

type PropMapping<P> = (keyof P & string) | (keyof P & string)[]

export function withLock<P extends Record<string, any>>(
  WrappedComponent: ComponentType<P>,
  propMapping: PropMapping<P>,
): ComponentType<P> {
  const props = Array.isArray(propMapping) ? propMapping : [propMapping]

  const Wrapper = forwardRef((ownProps: any, ref: any) => {
    const locked = useLockable()

    const mergedProps = { ...ownProps }
    for (const propName of props) {
      mergedProps[propName] = !!(locked || ownProps[propName])
    }

    return createElement(WrappedComponent, { ref, ...mergedProps })
  })

  Wrapper.displayName = `Lockable(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`

  return Wrapper as ComponentType<P>
}
